import DOMPurify from 'dompurify';

const DEFAULT_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'u',
  'span',
  'ul',
  'ol',
  'li',
  'blockquote',
  'code',
  'pre',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
];

const DEFAULT_ALLOWED_ATTR = [
  'class',
  'style',
  'title',
  'aria-label',
  'aria-hidden',
  'role',
];

export function sanitizeHtml(input, options = {}) {
  const html = String(input ?? '');
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: options.allowedTags ?? DEFAULT_ALLOWED_TAGS,
    ALLOWED_ATTR: options.allowedAttr ?? DEFAULT_ALLOWED_ATTR,
  });
}

